import webdesign from "../assets/svg/blogs/1.png";
import AI from "../assets/svg/blogs/2.png";
import ChatGPT from "../assets/svg/blogs/3.png";

export const blogData = [
    {
        id: 1,
        title: 'Web Design Inspiration',
        description: 'Working as a web designer requires a lot of creativity, skills, and personal, and professional development. Those who perceive the world in a new way, find hidden patterns, make...',
        date: 'Mar 03, 2022',
        image: webdesign,
        url: 'https://simratsinghtechnodiary.blogspot.com/2022/04/web-design-inspiration.html'
    },

    {
        id: 2,
        title: 'Artificial Intelligence',
        description: 'Artificial Intelligence (AI) is a rapidly growing field that has the potential to revolutionize the way we live and work. It involves the development of computer systems that can perform tasks that ...',
        date: 'Jan 28, 2023',
        image: AI,
        url: 'https://simratsinghtechnodiary.blogspot.com/2023/01/artificial-intelligence.html'
    },

    {
        id: 3,
        title: 'OpenAI ChatGPT',
        description: 'OpenAI ChatGPT is a large language model developed by OpenAI that is trained on a massive amount of data. It is based on the GPT (Generative Pre-trained Transformer) architecture, which is a type of neural network that is...',
        date: 'Jan 29, 2023',
        image: ChatGPT,
        url: 'https://simratsinghtechnodiary.blogspot.com/2023/01/openai-chatgpt-chatgpt-is-large.html'
    },
    
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/